(function () {
  'use strict';

  function initSection(section) {
    if (section.dataset.lightboxInit === 'true') return;
    var dialog = section.querySelector('[data-lightbox-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    section.dataset.lightboxInit = 'true';

    var image = dialog.querySelector('[data-lightbox-image]');

    section.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-lightbox-trigger]');
      if (!trigger || !section.contains(trigger)) return;
      event.preventDefault();
      image.src = trigger.dataset.lightboxSrc || '';
      image.alt = trigger.dataset.lightboxAlt || '';
      if (trigger.dataset.lightboxWidth) image.setAttribute('width', trigger.dataset.lightboxWidth);
      if (trigger.dataset.lightboxHeight) image.setAttribute('height', trigger.dataset.lightboxHeight);
      dialog.showModal();
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog || event.target.closest('[data-lightbox-close]')) {
        dialog.close();
      }
    });

    dialog.addEventListener('close', function () {
      image.removeAttribute('src');
      image.removeAttribute('width');
      image.removeAttribute('height');
      image.alt = '';
    });
  }

  function initAll(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll('.brand-logos');
    for (var i = 0; i < sections.length; i++) initSection(sections[i]);
    if (scope !== document && scope.classList && scope.classList.contains('brand-logos')) {
      initSection(scope);
    }
  }

  initAll();

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
